import React from 'react';
import T from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { Checkbox, Input, Form } from 'antd';

import { MODAL_SIGNUP } from '../../../../constants/app';

import { rootDomainUrl } from '../../../../utils/url';
import { getReferral, getAffiliate } from '../../../../utils/rewardful';

import AuthFormLinks from '../../../authFormLinks';
import ErrorAlert from '../../../errorAlert';
import Modal from '../../../modal';
import FormItem from '../../../formItem';

import { config } from './config';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 19 },
  },
};

const checkboxesFormItemLayout = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 19, offset: 5 },
  },
};

const SignupModal = ({ error, errorMessage, isLoading, reset, signup }) => {
  const handleOnFinish = (v) => {
    const values = {
      ...v,
      referral: getReferral(),
      affiliate: getAffiliate(),
    };

    signup(values);
  };

  return (
    <Modal
      name={MODAL_SIGNUP}
      okButtonProps={{ htmlType: 'submit', form: MODAL_SIGNUP, loading: isLoading }}
      okText="Sign Up"
      onCancel={reset}
      title="Sign Up"
    >
      <ErrorAlert message={errorMessage} visible={error} />

      <Form name={MODAL_SIGNUP} onFinish={handleOnFinish} {...formItemLayout}>
        <FormItem label="First Name" name="firstName" {...config.firstName}>
          <Input />
        </FormItem>
        <FormItem label="Last Name" name="lastName" {...config.lastName}>
          <Input />
        </FormItem>
        <FormItem label="E-mail" name="email" {...config.email}>
          <Input />
        </FormItem>
        <FormItem label="Password" name="password" {...config.password}>
          <Input.Password />
        </FormItem>

        <ThemeProvider theme={{ noMarginBottom: true }}>
          <FormItem name="terms" {...checkboxesFormItemLayout} {...config.terms}>
            <Checkbox>
              I agree to the{' '}
              <a href={rootDomainUrl('/terms-and-conditions')} rel="noopener noreferrer" target="_blank">
                Terms & Conditions
              </a>
              .
            </Checkbox>
          </FormItem>
        </ThemeProvider>

        <FormItem name="newsletter" {...checkboxesFormItemLayout} {...config.newsletter} initialValue={false}>
          <Checkbox>
            I want to receive on-chain market insights via email, in accordance with the{' '}
            <a href={rootDomainUrl('/privacy-notice')} rel="noopener noreferrer" target="_blank">
              Privacy Notice
            </a>
            .
          </Checkbox>
        </FormItem>
      </Form>
      <AuthFormLinks login resendConfirmation />
    </Modal>
  );
};

SignupModal.propTypes = {
  reset: T.func.isRequired,
  signup: T.func.isRequired,

  error: T.bool.isRequired,
  errorMessage: T.string,
  isLoading: T.bool.isRequired,
};

SignupModal.defaultProps = {
  errorMessage: '',
};

export default SignupModal;
